import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "variant", "size", "children"];
import React, { forwardRef } from 'react';
import ThemedBox from 'components/ThemedBox';
var variantProps = {
  default: {
    boxShadow: 'soft',
    name: 'card'
  },
  clickable: {
    boxShadow: 'soft',
    boxShadowOnHover: 'softHover',
    name: 'card'
  },
  raised: {
    boxShadow: 'raised',
    name: 'card'
  },
  inverted: {
    boxShadow: 'soft',
    name: 'invertedCard'
  }
};
var Card = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    /*
    Warning!!! `ThemedBox` is currently not being properly typechecked.
    Comment out `otherProps` and `as` when making changes to check types 
             */
    React.createElement(ThemedBox, _extends({
      ref: ref,
      width: "100%",
      overflow: "hidden",
      as: as || 'div'
    }, otherProps, {
      borderRadius: size
    }, variantProps[variant]), children)
  );
});
Card.displayName = 'Card';
export default Card;